<template>
    <!-- 对话框 -->
    <el-dialog :title="name + '的账单'" :visible.sync="show" :before-close="closeDialog" width="90%">
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <div>
                            <el-form-item label="对应表:">
                                <span>{{ props.row.table_name }}</span>
                            </el-form-item>
                        </div>

                        <div>
                            <el-form-item label="相关编号:">
                                <span>{{ props.row.record_code }}</span>
                            </el-form-item>
                        </div>
                    </el-form>
                </template>
            </el-table-column>

            <el-table-column prop="id" label="id"> </el-table-column>

            <el-table-column prop="consumer_name" label="客户姓名"> </el-table-column>
            <el-table-column prop="consumer_phone" label="客户电话"> </el-table-column>
            <el-table-column prop="start_name" label="出发地点"> </el-table-column>
            <el-table-column prop="end_name" label="目的地"> </el-table-column>
            <el-table-column prop="driver_name" label="代驾司机"> </el-table-column>

            <el-table-column prop="charge_money" label="充值"> </el-table-column>

            <el-table-column prop="" label="消费金额">
                <template slot-scope="props">
                    <div v-if="props.row.mode.val!='add'">
                        {{props.row.amount}}
                    </div>
                </template> </el-table-column>
            <el-table-column prop="surplus" label="余额"> </el-table-column>

            <el-table-column prop="description" label="描述"> </el-table-column>

            <el-table-column prop="time.YmdHis" label="创建时间"> </el-table-column>

            <el-table-column prop="mode.alias" label="账本模式"> </el-table-column>

            <el-table-column prop="remark" label="备注"> </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div style="text-align: right">
            <el-pagination layout="prev, pager, next" :total="result_data_children.count" @current-change="pages_function"> </el-pagination>
        </div>

        <div style="display: flex; justify-content: center">
            <el-button
                type="primary"
                :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'"
                @click="toExport"
                :disabled="progress_show"
                >{{ progress_show ? '导出中...' : '导出' }}</el-button
            >

            <el-button @click="closeDialog">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: '',
        name: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.search_data_children.group_wallet_code = _this.data;

            console.log(_this.data);

            _this.recordInit();
        }
    },
    data() {
        return {


            show: false,

            progress_show: false,

            excelData: [],

            excelHead: [],

            tableData: [],

            //翻页数据
            search_data_children: {
                page: 1,
                limit: 10,
                group_wallet_code: ''
            },

            result_data_children: [],
            search_rules_children: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        toExport() {
            _this.search_data_children.page = 1;
            _this.getExcelData();
        },

        getExcelData() {
            _this.progress_show = true;
            _this
                .$post('/group/groupRecordCSV', {
                    page: _this.search_data_children.page,
                    group_wallet_code: _this.search_data_children.group_wallet_code
                })
                .then((res) => {
                    if (this.$route.path == '/group') {
                        console.log(res.data);
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.result.length; i++) {
                            console.log(111);


                            _this.excelData.push({
                                consumer_name: res.data.result[i].consumer_name,
                                consumer_phone: res.data.result[i].consumer_phone,
                                start_name: res.data.result[i].start_name,
                                end_name: res.data.result[i].end_name,
                                driver_name: res.data.result[i].driver_name,
                                charge_money: res.data.result[i].amount,
                                amount: res.data.result[i].amount,
                                surplus: res.data.result[i].surplus,
                                description: res.data.result[i].description,
                                time: res.data.result[i].time.YmdHis,
                                mode: res.data.result[i].mode.alias,
                                remark: res.data.result[i].remark
                            });
                        }

                        for(let i = 0;i<res.data.result.length;i++) {
                            if (res.data.result[i].mode.val == 'add') {
                                for(let i = 0; i< _this.excelData.length;i++){
                                    console.log();

                                   _this.excelData[i].amount = 0

                                }
                            }

                        }




                        if (res.data.page * res.data.limit < res.data.count) {
                            _this.search_data_children.page = res.data.page + 1;

                            // _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

                            _this.getExcelData();
                        } else {
                            console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data_children.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                        }
                    } else {
                        _this.progress_show = false;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = [
                '客户姓名',
                '客户电话',
                '出发地点',
                '目的地',
                '代驾司机',
                '充值',
                '消费金额',
                '余额',
                '描述',
                '创建时间',
                '账本模式',
                '备注'
            ];
            const filterVal = [
                'consumer_name',
                'consumer_phone',
                'start_name',
                'end_name',
                'driver_name',
                'charge_money',
                'amount',
                'surplus',
                'description',
                'time',
                'mode',
                'remark'
            ];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '集团账单导出');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        // 获取钱包信息
        recordInit() {
            _this
                .$post('/group/groupRecordLists', _this.search_data_children, _this.search_rules_children)
                .then((res) => {
                    // 将获取到的数据赋值

                    _this.tableData = res.data.result;
                    console.log(res.data.result,'res.data.result');


                    _this.result_data_children = res.data;
                    console.log(res.data);
                })
                .catch((err) => {});
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
        },

        //翻页组件的回调
        pages_function(val) {
            _this.search_data_children.page = val;

            //初始化列表
            _this.recordInit();
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
</style>
